import { RefObject } from 'react';
import { twMerge } from 'tailwind-merge';

import { useTranslate } from '@growtherapy/i18n';
import { Text } from '@growtherapy/sprout-ui';

export type KeyProps = {
  letter: string;
  image: string;
  note: string;
  playNote: () => void;
  stopNote: () => void;
  offset: { x: number; y: number };
  imageRef: RefObject<HTMLImageElement>;
  classOverride?: string;
};

const SPACE_KEY = ' ';

const ENTER = 'ENTER';

export function Key({ letter, note, image, imageRef, offset, playNote, stopNote, classOverride = '' }: KeyProps) {
  const t = useTranslate();
  return (
    <button
      className={twMerge(
        'relative w-full h-1/5 sm:w-fit sm:h-fit transition-all ease-linear duration-[4000ms] group outline-none flex flex-col items-center justify-center',
        classOverride,
      )}
      aria-label={t('telehealth-core:waitingRoom.playNotePressingTheKeyWillAlsoPlayThisNote', { note, letter })}
      onMouseDown={playNote}
      onMouseUp={stopNote}
      onKeyDown={(event) => {
        const normalizedEventKey = event.key.toUpperCase();
        if (normalizedEventKey === SPACE_KEY || normalizedEventKey === ENTER) {
          playNote();
        }
      }}
      onKeyUp={(event) => {
        const normalizedEventKey = event.key.toUpperCase();
        if (normalizedEventKey === SPACE_KEY || normalizedEventKey === ENTER) {
          stopNote();
        }
      }}
    >
      <span className='flex w-full h-full sm:w-64 sm:h-64 hover:scale-125 group-focus:scale-125 transition-transform ease-out duration-500 relative inline-block'>
        <img
          alt=''
          src={image}
          className='h-full w-full block absolute top-0 transition-all ease-linear duration-[4000ms]'
          ref={imageRef}
          style={{
            transform: `translate(${offset.x}px, ${offset.y}px)`,
          }}
        />
      </span>
      <Text className='hidden sm:block rebrand:text-text-inverse'>{letter}</Text>
    </button>
  );
}
